import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import { useNotifications } from 'Shared/Notification';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const VertNotificationRefresh = ({ children }) => {
  const accessToken = useSelector((state) => state.oidc.user.access_token);
  const { isPMO, isLead, getRedemptionSpotGroups } = useParticipantSubSegment();
  const validGroup = getRedemptionSpotGroups();

  const { addNotification, clearNotificationByName } = useNotifications();
  const { isLoadingUser } = useSelector((state) => state.oidc);
  const { loadingSubsegmento, loadingIsManager } = useSelector(
    (state) => state.SpotGroups
  );
  const [lastPathname, setLastPathname] = useState('');
  const location = useLocation();
  const { pathname } = location;

  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile },
  } = userInfos;

  useEffect(() => {
    if (lastPathname !== pathname) {
      setLastPathname(pathname);
    }
  }, [pathname]);

  useEffect(() => {
    const controller = new AbortController();

    if (userInfos?.isLoaded) {
      const username = profile?.username || profile['custom:login'];
      const config = {
        campaignId: userProfile['custom:campaign_id'],
        catalogId: userProfile['custom:catalog_id'],
        participantId: userProfile['custom:participant_id'],
        Authorization: `Bearer ${accessToken}`,
        username: username,
      };

      const getPendingValidation = async () => {
        let PartipantStatus = 0;
        if (isPMO) {
          PartipantStatus = 2;
        } else if (isLead) {
          PartipantStatus = 3;
        } else {
          PartipantStatus = 4;
        }

        await redemptionsApiClient
          .get(`/redemption/count?Status=${PartipantStatus}`, {
            headers: config,
            signal: controller.signal,
          })
          .then((res) => {
            if (res.data.count !== 0) {
              addNotification('Spot_Aprovacoes_Pendentes', {
                title: 'Aprovações Pendentes',
                message: 'Você possui aprovações pendentes',
                date: new Intl.DateTimeFormat('pt-BR').format(new Date()),
                read: false,
                href: '/list-redemptions',
                hrefText: 'Clique  para acessar',
              });
            } else {
              clearNotificationByName('Spot_Aprovacoes_Pendentes');
            }
          })
          .catch((err) => {
            console.log('getAllPendingValidations err ::: ', err);
          });
      };

      getPendingValidation();
    }

    return () => {
      controller.abort();
    };
  }, [isLoadingUser, pathname, isLead, isPMO]);

  return <>{children}</>;
};

export default VertNotificationRefresh;
